import {iosVhFix} from './utils/ios-vh-fix';
import {initPreloader} from './modules/init-preloader';
import {initModals} from './modules/modals/init-modals';
import {initHeader} from './modules/init-header';
import {initMenu} from './modules/init-menu';
import {initAudioPlayer} from './modules/init-audio-player';
import {initTrackHandlers} from './modules/init-track-handlers';
import {initVideos} from './modules/init-videos';
import {initSchemePoints} from './modules/init-scheme-points';
import {initVRVideos} from './modules/init-vr-videos';
import {staticVh} from './utils/static-vh';
import {initSliders} from './modules/init-sliders';
import {initUpButton} from './modules/init-up-btn';
import {initMoveTo} from './modules/init-move-to';
import {initZoom} from './modules/init-zoom';
import {initScrollAnimation} from './modules/animation/scroll-animation';
import {initNavigationChanger} from './modules/navigation-changer/init-navigation-changer';

// ---------------------------------


window.addEventListener('DOMContentLoaded', () => {

  // Utils
  // ---------------------------------
  iosVhFix();
  staticVh();

  // Modules
  // ---------------------------------
  initPreloader();

  initHeader();
  initMenu();
  initMoveTo();
  initVideos();
  initAudioPlayer();
  initSchemePoints();
  initVRVideos();
  initUpButton();
  initSliders();
  initZoom();
  initScrollAnimation();
  initNavigationChanger();
  initTrackHandlers();

  // все скрипты должны быть в обработчике 'DOMContentLoaded', но не все в 'load'
  // в load следует добавить скрипты, не участвующие в работе первого экрана
  window.addEventListener('load', () => {
    initModals();
  });
});
